import React, { useState } from 'react';
import axios from 'axios';
import './JoinFreelancer.css';

function JoinFreelancer() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    skills: '',
    bio: '',
    portfolio: '',
    github: '',
    linkedin: '',
    hourlyRate: '',
    availability: 'full-time',
    experience: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Convert skills string to array
      const skillsArray = formData.skills.split(',').map(skill => skill.trim()).filter(skill => skill);
      
      const submitData = {
        ...formData,
        skills: skillsArray,
        hourlyRate: parseFloat(formData.hourlyRate) || 0,
        experience: parseInt(formData.experience) || 0
      };

      const response = await axios.post('http://localhost:5001/api/forms/freelancer-application', submitData);
      
      setSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        skills: '',
        bio: '',
        portfolio: '',
        github: '',
        linkedin: '',
        hourlyRate: '',
        availability: 'full-time',
        experience: ''
      });
    } catch (err) {
      setError(err.response?.data?.message || 'Σφάλμα κατά την υποβολή της αίτησης');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="join-freelancer-page">
        <div className="success-message-container">
          <div className="success-icon">✅</div>
          <h1>Η Αίτησή σας Υποβλήθηκε Επιτυχώς!</h1>
          <p>Ευχαριστούμε για το ενδιαφέρον σας να γίνετε μέλος της ομάδας μας.</p>
          <p>Θα εξετάσουμε την αίτησή σας και θα επικοινωνήσουμε μαζί σας σύντομα.</p>
          <button 
            className="btn btn-primary"
            onClick={() => setSubmitted(false)}
          >
            Υποβολή Νέας Αίτησης
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="join-freelancer-page">
      <div className="join-hero">
        <div className="container">
          <h1 className="join-title">Γίνε Μέλος της Ομάδας μας</h1>
          <p className="join-subtitle">
            Συνεργάσου με τις καλύτερες επιχειρήσεις και αξιοποίησε τις δεξιότητές σου
          </p>
        </div>
      </div>

      <div className="container">
        <div className="join-content">
          <div className="benefits-section">
            <h2>Γιατί να Γίνεις Freelancer στο Freelancher;</h2>
            <div className="benefits-grid">
              <div className="benefit-card">
                <div className="benefit-icon">💼</div>
                <h3>Ποιοτικά Έργα</h3>
                <p>Πρόσβαση σε επιλεγμένα projects από αξιόπιστες επιχειρήσεις</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">💰</div>
                <h3>Ανταγωνιστικές Αμοιβές</h3>
                <p>Καθόρισε εσύ το hourly rate σου και διαπραγματεύσου τους όρους</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">🚀</div>
                <h3>Επαγγελματική Ανάπτυξη</h3>
                <p>Δούλεψε σε challenging projects και εξελίξου συνεχώς</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">🤝</div>
                <h3>Υποστήριξη</h3>
                <p>Ομάδα υποστήριξης διαθέσιμη να σε βοηθήσει ανά πάσα στιγμή</p>
              </div>
            </div>
          </div>

          <div className="form-section">
            <h2>Συμπλήρωσε την Αίτησή σου</h2>
            
            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="freelancer-form">
              <div className="form-section-title">Προσωπικά Στοιχεία</div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Ονοματεπώνυμο *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="π.χ. Γιώργος Παπαδόπουλος"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Τηλέφωνο</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="69XXXXXXXX"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="experience">Χρόνια Εμπειρίας *</label>
                  <input
                    type="number"
                    id="experience"
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                    required
                    min="0"
                    placeholder="π.χ. 5"
                  />
                </div>
              </div>

              <div className="form-section-title">Επαγγελματικά Στοιχεία</div>

              <div className="form-group">
                <label htmlFor="skills">Δεξιότητες *</label>
                <input
                  type="text"
                  id="skills"
                  name="skills"
                  value={formData.skills}
                  onChange={handleChange}
                  required
                  placeholder="π.χ. React, Node.js, Python, MongoDB (χωρισμένες με κόμμα)"
                />
                <small>Γράψε τις δεξιότητές σου χωρισμένες με κόμμα</small>
              </div>

              <div className="form-group">
                <label htmlFor="bio">Σύντομη Βιογραφία *</label>
                <textarea
                  id="bio"
                  name="bio"
                  value={formData.bio}
                  onChange={handleChange}
                  required
                  rows="4"
                  placeholder="Πες μας λίγα λόγια για την εμπειρία και τις ειδικότητές σου..."
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="hourlyRate">Ωριαία Αμοιβή (€) *</label>
                  <input
                    type="number"
                    id="hourlyRate"
                    name="hourlyRate"
                    value={formData.hourlyRate}
                    onChange={handleChange}
                    required
                    min="0"
                    step="5"
                    placeholder="π.χ. 45"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="availability">Διαθεσιμότητα *</label>
                  <select
                    id="availability"
                    name="availability"
                    value={formData.availability}
                    onChange={handleChange}
                    required
                  >
                    <option value="full-time">Full-time</option>
                    <option value="part-time">Part-time</option>
                    <option value="weekends">Σαββατοκύριακα</option>
                  </select>
                </div>
              </div>

              <div className="form-section-title">Links & Portfolio</div>

              <div className="form-group">
                <label htmlFor="portfolio">Portfolio URL</label>
                <input
                  type="url"
                  id="portfolio"
                  name="portfolio"
                  value={formData.portfolio}
                  onChange={handleChange}
                  placeholder="https://yourportfolio.com"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="github">GitHub Profile</label>
                  <input
                    type="url"
                    id="github"
                    name="github"
                    value={formData.github}
                    onChange={handleChange}
                    placeholder="https://github.com/yourusername"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="linkedin">LinkedIn Profile</label>
                  <input
                    type="url"
                    id="linkedin"
                    name="linkedin"
                    value={formData.linkedin}
                    onChange={handleChange}
                    placeholder="https://linkedin.com/in/yourusername"
                  />
                </div>
              </div>

              <button 
                type="submit" 
                className="btn btn-primary btn-large btn-submit"
                disabled={loading}
              >
                {loading ? '⏳ Υποβολή...' : '🚀 Υποβολή Αίτησης'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JoinFreelancer;
